import React           from 'react';
import PriceMatrixBody from './PriceMatrixBody';
import PriceMatrixHead from './PriceMatrixHead';
import PropTypes       from 'prop-types'

const PriceMatrix = (props) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-price-matrix">
        <PriceMatrixHead usCombined={props.usCombined} />
        <PriceMatrixBody
          usCombined={props.usCombined}
          quoteStep={props.quoteStep}
          parameters={props.parameters}
          parametersChanged={props.parametersChanged}
          onPriceSelect={props.onPriceSelect}
          showSummary={props.showSummary} />
      </table>
    </div>
  );
};

PriceMatrix.propTypes = {
  usCombined: PropTypes.object.isRequired,
  quoteStep: PropTypes.string.isRequired,
  parameters: PropTypes.object.isRequired,
  parametersChanged: PropTypes.bool.isRequired,
  onPriceSelect: PropTypes.func.isRequired,
}

export default PriceMatrix;
